import { IconPrescription as FigmaIconPrescription } from '@redteclab/icons'
import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const IconPrescription: FC<IconProps> = props => (
  <SvgIcon {...props} component={FigmaIconPrescription} />
)

export default IconPrescription
